import React from "react";
import Page from "../components/Page";
import EmbeddedDashboard from "../components/Dashboards/CompanySummary";

const Overall: React.FC = () => {
    return (
        <Page>
            <EmbeddedDashboard />
        </Page>
    );
};

export default Overall;
